/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

import { isVerticalDock } from './drawerLayout';

/**
 * @param {import('@mui/material').Theme} theme
 * @param {{ anchor?: string }} options
 * @returns {import('@mui/system').SxProps}
 */
export const getResizeHandleSx = (theme, { anchor = 'right' } = {}) => {
  const vertical = isVerticalDock(anchor);

  if (anchor === 'left') {
    return {
      position: 'absolute',
      right: 0,
      top: 0,
      bottom: 0,
      width: 8,
      zIndex: theme.zIndex.drawer + 1,
      cursor: 'col-resize',
      touchAction: 'none',
      bgcolor: 'transparent',
      '&:hover': {
        bgcolor: 'action.hover',
      },
      '&:active': {
        bgcolor: 'action.selected',
      },
    };
  }

  if (anchor === 'right') {
    return {
      position: 'absolute',
      left: 0,
      top: 0,
      bottom: 0,
      width: 8,
      zIndex: theme.zIndex.drawer + 1,
      cursor: 'col-resize',
      touchAction: 'none',
      bgcolor: 'transparent',
      '&:hover': {
        bgcolor: 'action.hover',
      },
      '&:active': {
        bgcolor: 'action.selected',
      },
    };
  }

  if (anchor === 'bottom') {
    return {
      position: 'absolute',
      left: 0,
      right: 0,
      top: 0,
      height: 8,
      zIndex: theme.zIndex.drawer + 1,
      cursor: 'row-resize',
      touchAction: 'none',
      bgcolor: 'transparent',
      '&:hover': {
        bgcolor: 'action.hover',
      },
      '&:active': {
        bgcolor: 'action.selected',
      },
    };
  }

  if (anchor === 'top') {
    return {
      position: 'absolute',
      left: 0,
      right: 0,
      bottom: 0,
      height: 8,
      zIndex: theme.zIndex.drawer + 1,
      cursor: 'row-resize',
      touchAction: 'none',
      bgcolor: 'transparent',
      '&:hover': {
        bgcolor: 'action.hover',
      },
      '&:active': {
        bgcolor: 'action.selected',
      },
    };
  }

  return {
    position: 'absolute',
    ...(vertical
      ? { left: 0, top: 0, bottom: 0, width: 8, cursor: 'col-resize' }
      : { left: 0, right: 0, top: 0, height: 8, cursor: 'row-resize' }),
    zIndex: theme.zIndex.drawer + 1,
    touchAction: 'none',
    bgcolor: 'transparent',
  };
};
